// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"CTA_Wrapper__iF7AW","Card":"CTA_Card__BXzqo","Title":"CTA_Title__QMfgC"};